import {LoadingView} from "../../designSystem/components/LoadingView";
import {NoPermissionView} from "./NoPermissionView";

export const RoleGuard = ({
  userToken,
  role,
  allowedRoles,
  children,
}) => {
  if (!userToken) return <LoadingView />
  if (!role) return <NoPermissionView />;
  if (!(allowedRoles.includes(role))) return <NoPermissionView />;
  return children;
};